import { ClassSubjectTeachersType } from "../../../types/Teacher";
import { put } from "../../../utils/axios-config";
import { TEACHERS_CLASSES_SUBJECTS } from "../../../utils/constants";

export const updateTeacherClassSubject = async (data: ClassSubjectTeachersType) => await put<ClassSubjectTeachersType, boolean>(TEACHERS_CLASSES_SUBJECTS, data);